import React from 'react';

import {formatISO} from 'date-fns';
import {useStore} from 'effector-react';
import {useTranslation} from 'react-i18next';

import {Button, ButtonVariant} from 'components/ui-kit/Button';
import {Modal} from 'components/ui-kit/Modal';

import {
    recallData$,
    recallGtinFx,
    showRecallApproveModal$,
    showRecallApproveModalChanged,
} from 'models/registries/gtinsGrid/upload';

import {ButtonWrapper, ModalText, Root} from './styled';

export const RecallApproveModal = () => {
    const {t} = useTranslation();
    const recallData = useStore(recallData$);
    const isModalOpen = useStore(showRecallApproveModal$);
    const onClose = () => {
        showRecallApproveModalChanged(false);
    };

    const onRecall = () => {
        recallGtinFx({
            gtin: recallData.productCode,
            reason: recallData.reason,
            ...(recallData.batchNumber && {batchNumber: recallData.batchNumber}),
            ...(recallData.comment && {comment: recallData.comment}),
            ...(recallData.documentNumber && {
                regulatorDocumentNumber: recallData.documentNumber,
            }),
            ...(recallData.recallDate && {
                recallDecisionDate: formatISO(recallData.recallDate),
            }),
        });
        onClose();
    };

    return (
        <Modal
            modalWidth={0}
            show={isModalOpen}
            onClose={onClose}
            title={t('pages.products.recallForm.recallConfirmationModal.title')}
        >
            <Root>
                <ModalText>
                    {t('pages.products.recallForm.recallConfirmationModal.description')}
                </ModalText>
                <ButtonWrapper>
                    <Button size="sm" variant={ButtonVariant.Outline} onClick={onClose}>
                        {t('pages.products.recallForm.recallConfirmationModal.cancel')}
                    </Button>
                    <Button size="sm" variant={ButtonVariant.Normal} onClick={onRecall}>
                        {t('pages.products.recallForm.recallConfirmationModal.recall')}
                    </Button>
                </ButtonWrapper>
            </Root>
        </Modal>
    );
};
